import { Heading } from 'components'
import React, { useState } from 'react'
import StorageService from 'utils/StorageServices';
import { CommonReportFilters } from '..';
import moment from 'moment';
import { API, AppConfig } from 'lib';

const LrDetailReport = () => {

  const [loading, setLoading] = useState(false);
  let isToken = localStorage.getItem("token");

  const currentDate = new Date();
  const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
  const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

  const [filter, setFilter] = useState({
    company_id: '',
    start_date: moment(firstDay).subtract(31, 'days'),
    end_date: moment(lastDay),
  });

  const getDownloadLrDetailReport = async () => {
    setLoading(true)
    try {
      const payload = {
        company_id: StorageService.getCompanyId(),
        consignor_id: filter?.consignor_id?.value ? filter?.consignor_id?.value : '',
        branch_id: filter?.branch_id?.value ? filter?.branch_id?.value : '',
        // ownership_no: filter?.ownership_no?.value ? filter?.ownership_no?.value : '',
        from_location: filter?.from_location?.value ? filter?.from_location?.value : '',
        to_location: filter?.to_location?.value ? filter?.to_location?.value : '',
        eway_bill_status: filter?.eway_bill_status?.value ? filter?.eway_bill_status?.value : '',
        pod_status: filter?.pod_status?.value ? filter?.pod_status?.value : '',
        status: filter?.status?.value ? filter?.status?.value : '',
        start_date: moment(filter.start_date).format("YYYY-MM-DD"),
        end_date: moment(filter.end_date).format("YYYY-MM-DD"),
      }
      const response = await fetch(`${AppConfig.api_baseurl}${API.LR_DETAIL_REPORT_EXCEL}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Token': `${isToken}`,
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'LR Detail Report.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  return (
    <>
      <Heading title="LR Detail Report" />
      <div className='_mrktLoad_mainBx __main_p_n_l _trpRevenue _ctLoad_cts _ctBx_mainBx'>

        <CommonReportFilters
          filter={filter}
          setFilter={(e) => setFilter(e)}
          isVehicleNumberDropdown={false}
          isSupplierDropdown={false}
          isDriverDropdown={false}
          isVehicleOwnershipDropdown={false}
          isStatusDropdown = {false}
        />

      </div>

      <div className='paginationFt_avt' style={{ justifyContent: "flex-start", alignItems: "center" }}>
        <button className='_addComm_btn' onClick={(e) => getDownloadLrDetailReport(e)} disabled={loading}> {loading ? 'Loading...' : 'Download'} </button>
      </div>
    </>
  )
}

export default LrDetailReport